// Routing policy for B2B checkout.
//
// Orders at or above the PO threshold must be submitted as a Purchase
// Order pending internal approval; below the threshold a NetSuite Sales
// Order can be created immediately. Threshold is configurable via env so
// finance can dial it.

export const PO_THRESHOLD_USD = (() => {
  const raw = Number(import.meta?.env?.VITE_PO_THRESHOLD_USD);
  return Number.isFinite(raw) && raw > 0 ? raw : 10000;
})();

export function checkoutRoute(subtotal) {
  return Number(subtotal) >= PO_THRESHOLD_USD ? "po" : "sales-order";
}
